const JumpSpotHover = ({ onClick }) => {
  return <div className="jumpspot-hover-container" onClick={onClick}></div>;
};

export default JumpSpotHover;
